import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Typography, Switch } from 'foundations-library/components'
import * as GTM from '../../../util/GTM'

const useStyles = makeStyles(theme => {
    const { colors } = theme['foundations-library']

    return {
        layoutContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '3px',
            alignSelf: 'stretch'
        },
        layout: {
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'stretch'
        },
        billingCycle: {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0 0'
        },
        switchContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            marginLeft: 'auto'
        },
        switch: {

        },
        switchRoot: {
            margin: 0
        },
        footer: {
            maxWidth: '60%'
        },
        monthly: {
            color: ({ paymentPeriod }) => paymentPeriod === 1 ? colors.primary[400] : colors.neutral[600]
        },
        annually: {
            color: ({ paymentPeriod }) => paymentPeriod !== 1 ? colors.primary[400] : colors.neutral[600]
        }
    }
})

interface BillingCycleProps {
    paymentPeriod: number,
    onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void,
    disabled?: boolean
}

/**
 * UI to toggle between monthly and annual billing
 */
const BillingCycle = ({ paymentPeriod, onChange, disabled } : BillingCycleProps) : JSX.Element => {
    const classes = useStyles({ paymentPeriod })

    const onSwitchChanged = (checked: boolean) => {
        GTM.paymentPeriodChanging(checked ? 12 : 1)
        onChange(checked)
    }
    console.log('paymentPeriod', paymentPeriod)
    return (
        <div className={classes.layoutContainer}>
            <div className={classes.layout}>
                <Typography variant='subtitle3' color='neutral-900' remoteConfigID="signup_order_summary_billing_cycle" />
                <div className={classes.switchContainer}>
                    <Typography variant='subtitle3' className={classes.monthly} remoteConfigID="signup_order_summary_billing_cycle_monthly" />
                    <Switch
                        className={classes.switch}
                        data-testid='payment-period-switch'
                        checked={paymentPeriod === 12}
                        onChange={onSwitchChanged}
                        disabled={disabled}
                    />
                    <Typography variant='subtitle3' remoteConfigID="signup_order_summary_billing_cycle_annually" className={classes.annually} />
                </div>
            </div>
            <Typography remoteConfigID="signup_order_summary_billing_cycle_annual_savings" variant="body4" color="neutral-500" align="right" className={classes.footer} />
        </div>
    )
}

export default BillingCycle
